import React from 'react';
import './Carousal.css';

const ImageCarousal = (props) => {
    const parser = new DOMParser();
    const dom = parser.parseFromString(props.description, 'text/html');
    const title = parser.parseFromString(props.title, 'text/html');

    return (
        <>
            <div id="slide-header" className='slide-header'>
                <div id="app-logo" className="app-logo">
                    <img src={props.logoSrc} alt="logo" />
                </div>
                <div dangerouslySetInnerHTML={{ __html: title.body.innerHTML }} />
            </div>
            <div className="channels-title-holder">
                <div className="slide-description carausal-list-item-content" dangerouslySetInnerHTML={{ __html: dom.body.innerHTML }} />
            </div>
            <div id="slide-image-container" className='slide-image-container'>
                <h4 id="slide-image-text-title" className='slide-image-text-title'>{props.footerImageTitle}</h4>
                <img id="slide-item-image" src={props.footerImageSrc} alt="img" className="slide-item-image" />
            </div>
        </>
    );
}

export default ImageCarousal;